import { toastr } from 'react-redux-toastr';
import * as ReactGA from 'react-ga';
import { AuthTypes, defaultAuthPayload, IRefreshToken } from "./types";
import { CognitoLoginService } from '../../../share/services/cognito-login';
import { cognitoInfo } from '../../../share/config/cognito';
import storageManager from '../../../share/utils/localStorage';
import { AUTH_STORAGE_KEY } from '../../../share/utils/apiAuthToken';
import { AgenciesService } from '../../../share/services/agencies';
import routes from '../../Routing/routes';
import { NotificationsService } from 'src/share/services/notifications';
import { AuditService } from 'src/share/services/audit';
import { TermsOfUseService } from 'src/share/services/termsOfUse';
import { TermsOfUseUserStatus } from 'src/share/types/termsOfUse';
import { getUserType } from '../helpers/getUserType';

export const loginActions = {
    logout: (history: any): any =>
        async (dispatch: any) => {
            history.replace(routes.LOGIN);
            storageManager.clear();
            ReactGA.event({
                category: 'Logout',
                action: 'User logout',
                label: 'Login management'
            });
            dispatch({
                type: AuthTypes.LogOut
            })
        },
    logIn: (username: string, password: string): any =>
        async (dispatch: any) => {
            dispatch({
                type: AuthTypes.LogInLoading,
                payload: {
                    ...defaultAuthPayload,
                    username,
                    loading: true,
                }
            })
            const loginService = new CognitoLoginService(cognitoInfo);
            try {
                const response = await loginService.login(username, password);
                storageManager.save(AUTH_STORAGE_KEY, { idToken: response.getIdToken() });
                const authData = response.getIdToken().decodePayload()
                const agencyCode = authData['custom:agencyCode'];
                const lastLogin = await AuditService.logLogin(username);
                const agencies = await AgenciesService.get();
                const notifications = await NotificationsService.get();
                const userType = getUserType(authData);
                const termsOfUseStatus = await TermsOfUseService.getUserAgreementStatus(username);
                const payload = {
                    username,
                    idToken: response.getIdToken(),
                    accessToken: response.getAccessToken(),
                    refreshToken: response.getRefreshToken(),
                    errorMessage: '',
                    loading: false,
                    userType,
                    agencies,
                    agencyCode,
                    notifications,
                    lastLogin,
                    termsOfUseStatus
                };
                storageManager.save(AUTH_STORAGE_KEY, payload);
                ReactGA.event({
                    category: 'Login',
                    action: 'User login',
                    label: 'Login management'
                });
                dispatch({
                    type: AuthTypes.LogIn,
                    payload
                })
            } catch (error) {
                toastr.error('Login error', 'Login Failed!')
                storageManager.clear();
                dispatch({
                    type: AuthTypes.LogInFailed,
                    payload: {
                        ...defaultAuthPayload,
                        errorMessage: 'Login Failed!'
                    }
                })
            }
        },
    refreshLogIn: (username: string, refreshToken: IRefreshToken | null): any =>
        async (dispatch: any) => {
            if (refreshToken) {
                try {
                    const loginService = new CognitoLoginService(cognitoInfo);
                    const response = await loginService.refreshLoginSession(username, refreshToken);
                    const payload = {
                        idToken: response.idToken,
                        accessToken: response.accessToken,
                        refreshToken: response.refreshToken,
                        errorMessage: '',
                        loading: false
                    };
                    storageManager.save(AUTH_STORAGE_KEY, { ...storageManager.get(AUTH_STORAGE_KEY), ...payload });
                    ReactGA.event({
                        category: 'Login',
                        action: 'Refresh login',
                        label: 'Login management'
                    });
                    dispatch({
                        type: AuthTypes.RefreshLogin,
                        payload
                    })
                } catch (error) {
                    toastr.error('Login error', 'Login Failed!')
                    dispatch({
                        type: AuthTypes.LogInFailed,
                        payload: {
                            ...defaultAuthPayload,
                            errorMessage: 'Login Failed!'
                        }
                    })
                }
            }

        },
    getAgencies: (): any => async (dispatch: any) => {
        try {
            const agencies = await AgenciesService.get()
            dispatch({
                type: AuthTypes.GetAgencies,
                payload: {
                    agencies
                }
            })
        } catch (error) {
            toastr.error('Agencies', 'There was a problem loading the agencies')
        }
    },
    getNotifications: (): any => async (dispatch: any) => {
        try {
            const notifications = await NotificationsService.get();
            dispatch({
                type: AuthTypes.GetNotifications,
                payload: {
                    notifications
                }
            })
        } catch (error) {
            toastr.error('Notifications', 'There was a problem loading your notifications')
        }
    },
    deleteNotifications: (ids: string[], type: string): any => async (dispatch: any) => {
        try {
            await NotificationsService.remove(ids);
            dispatch({
                type: AuthTypes.DeleteNotifications,
                payload: {
                    type
                }
            })
        } catch (error) {
            toastr.error('Notifications', 'There was a problem removing your notifications')
        }
    },
    setTermsOfUserStatus: (termsOfUseStatus: TermsOfUseUserStatus) => (dispatch: any) => {
        storageManager.save(AUTH_STORAGE_KEY, { ...storageManager.get(AUTH_STORAGE_KEY), termsOfUseStatus });
        dispatch({
            type: AuthTypes.TermsOfUseStatus,
            payload: {
                termsOfUseStatus
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/modules/Auth/store/actions.ts